import React, { useState, useRef, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { addProductMediaBulk } from '../../store/features/groupsSlice';
import { ReactComponent as LoadingIcon } from '../../assets/images/loading.svg';
import { ReactComponent as DeleteIcon } from '../../assets/images/trash-red.svg';

import { addToast } from '../../store/features/toastSlice';
import DropDown from '../../components/McDropdown';
import Button from '../../components/Elements/button/button';
import { uploadMedia } from '../../store/services/media';
import * as XLSX from 'xlsx';

const ProductMediaBulk = () => {
  const dispatch = useDispatch();
  const [uploadingImage, setUploadingImage] = useState(false);
  const [bulkFile, setBulkFile] = useState(false);
  const [rows, setRows] = useState([]);
  const [importedSku, setImportedSku] = useState([]);

  const bulkInputRef = useRef(null);

  const onImport = async e => {
    const f = e.target.files?.[0];
    if (!f) return;
    const reader = new FileReader();

    reader.onload = e => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 }).slice(1);

      setRows(json);
    };

    reader.readAsArrayBuffer(f);
    setBulkFile({
      name: f.name,
      size: f.size,
    });
  };

  const importRows = async () => {
    setBulkFile(null);
    setImportedSku([]);
    const resoonse = await dispatch(
      addProductMediaBulk({
        body: rows.map(r => ({ sku: r[2], url: r[4] })),
      }),
    );
    setImportedSku(resoonse.map(r => r.product.sku));
    dispatch(addToast({ error: false, text: 'Product media imported' }));
  };

  return (
    <ProductMediaWrapper>
      <div className="flex flex-1">
        <div className="flex-column flex-1 mr-4">
          <label className="bold-text font-20 mb-6">Bulk Spec import</label>
          {bulkFile ? (
            <div className="flex mt-6" style={{ maxWidth: '400px' }}>
              <div className="flex-column flex-1">
                {bulkFile && <label className="regular-text">{bulkFile.name}</label>}
                {bulkFile.size && (
                  <label className="regular-text grey-text">{`${parseFloat(parseInt(bulkFile.size) / 1024).toFixed(
                    2,
                  )} kb`}</label>
                )}
              </div>
              <div
                className="pxy-1 radius-2 flex delete-widget h-fit-content cursor"
                onClick={() => {
                  setBulkFile(null);
                  setRows([]);
                  setImportedSku([]);
                }}>
                <DeleteIcon width={14} height={14} />
              </div>
            </div>
          ) : (
            <div className="flex items-center mt-6 col-gap-4">
              <input className="display-none" type="file" ref={bulkInputRef} onChange={onImport} />
              <Button
                icon={uploadingImage ? <LoadingIcon height={14} /> : <Fragment />}
                label={'Upload file'}
                size="medium"
                borderRadius="12px"
                className="primary-white flex-1"
                onClick={() => !uploadingImage && bulkInputRef.current.click()}
              />
              <label className="flex-1 regular-text font-12">XLSX</label>
            </div>
          )}
          <div>
            {rows.map(r => (
              <div
                key={r[0]}
                className="mb-2 mt-6"
                style={{
                  display: 'grid',
                  gridTemplateColumns: '100px 1.5fr 1fr',
                  color: importedSku.includes(r[2]) ? 'green' : 'black',
                }}>
                <label className="regulat-text font-12 mr-2">{r[0]}</label>
                <label className="regulat-text font-12 mr-2">{r[1]}</label>
                <label className="regulat-text font-12 mr-2">{r[2]}</label>
              </div>
            ))}
          </div>
          <div className="flex" style={{ maxWidth: '300px' }}>
            <Button
              {...{
                label: 'Import',
                size: 'medium',
                borderRadius: '8px',
                className: 'primary mt-6',
                width: '100px',
              }}
              disabled={!bulkFile}
              onClick={() => importRows()}
            />
          </div>
        </div>
      </div>
    </ProductMediaWrapper>
  );
};

const ProductMediaWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 48px;

  .scroll-text {
    overflow-y: scroll;
    max-height: 600px;
  }
`;

export default ProductMediaBulk;
